import { T } from '@/lib/theme'

/// Shared "the one number that matters" hero treatment - giant glowing figure,
/// eyebrow label, optional caption and action slot underneath. Used wherever a
/// section has a single headline metric worth making the visual anchor of the
/// page (Stake's claimable USDx, Earn's APY, Portfolio's total value) - one
/// consistent language instead of a different hero style invented per section.
export function HeroFigure({ eyebrow, value, caption, color = T.positive, action = null }) {
  return (
    <div style={heroWrap}>
      <div style={heroEyebrow}>{eyebrow}</div>
      <div style={{ ...heroNumber, color, textShadow: `0 0 60px ${color}55, 0 0 120px ${color}22` }}>{value}</div>
      {caption && <div style={heroCaption}>{caption}</div>}
      {action && <div style={heroAction}>{action}</div>}
    </div>
  )
}

const heroWrap = {
  display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
  padding: '64px 24px 56px',
}
const heroEyebrow = {
  color: T.textDim, fontFamily: T.fontM, fontSize: T.fs.caption, fontWeight: 700,
  letterSpacing: '0.16em', textTransform: 'uppercase',
}
const heroNumber = {
  marginTop: 14,
  fontFamily: T.fontN, fontWeight: 800, fontSize: 'clamp(56px, 10vw, 108px)',
  lineHeight: 1, letterSpacing: '-0.03em',
}
const heroCaption = {
  marginTop: 20, maxWidth: 480,
  color: T.textMuted, fontFamily: T.fontM, fontSize: T.fs.body, lineHeight: 1.6,
}
const heroAction = {
  marginTop: 24, width: '100%', maxWidth: 420,
}
